<template>
  <div class="flight-box">
    <van-list
      :loading-text="$t('loding…')"
      class="flight-list"
    >
      <!-- <van-cell>
        <van-row class="flight-list-header">
          <van-col span="4">{{ $t('Depart') }}</van-col>
          <van-col span="4">{{ $t('From') }}</van-col>
          <van-col span="4">{{ $t('To') }}</van-col>
          <van-col span="6">{{ $t('Status') }}</van-col>
          <van-col span="6">{{ $t('Flight') }}</van-col>
        </van-row>
      </van-cell> -->
      <van-cell
        v-for="(flight,index) in flightList"
        :key="index"
        @click="showDetail(flight)"
      >
        <van-row class="flight-list-item">
          <van-col span="4">{{renderTime(flight.FlightDeptimePlanDate)}}</van-col>
          <van-col span="3">{{flight.FlightDepcode}}</van-col>
          <van-col span="3">{{flight.FlightArrcode}}</van-col>
          {{ (str = flight.FlightState[0].toUpperCase() + flight.FlightState.substring(1), void 0) }}
          <van-col span="7" :class="'flight-status-text ' + flight.FlightState">{{ $t(formatStatus(str)) }}</van-col>
          <van-col span="6" class="flight-number"><img class="airline-logo"
                                                       :src="`/img/aircorp/${flight.FlightNo.substring(0, 2).toLowerCase()}.png`"
                                                       alt="">{{flight.FlightNo}}
          </van-col>
        </van-row>
      </van-cell>
    </van-list>
  </div>
</template>

<script>
export default {
  name: 'FlightList',
  props: ['flightList', 'from'],
  methods: {
    renderTime (time) {
      if (!time) {
        return '--'
      }
      return this.$moment(time).format('HH:mm')
    },
    showDetail (flight) {
      localStorage.setItem('isArrival', 0)
      this.$store.state.flight = flight
      this.$store.commit('setFlight', flight)
      let fnum = flight.FlightNo
      let date = this.$moment(flight.FlightDeptimePlanDate).format('YYYY-MM-DD')
      let dep = flight.FlightDepcode
      let arr = flight.FlightArrcode
      this.$gtm.push({
        'event': 'screenview',
        'site_type': sessionStorage.getItem('site_type'),
        'brand': 'edreams',
        'screenName': '/flights-tracker/' + this.from + '/flights-detail/',
        'lang': localStorage.getItem('cod_lang') || localStorage.getItem('lang'),
        'cid': localStorage.getItem('cid')
      })
      this.$router.push(`/flight?fnum=${fnum}&dep=${dep}&arr=${arr}&date=${date}&cid=${localStorage.getItem('cid')}`)
    },
    formatStatus (status) {
      if (status === 'Cancel in advance') {
        return 'Cancel'
      }
      if (status === 'Cruising' || status === 'Descending' || status === 'Landing' || status === 'Climbing') {
        return 'Departed'
      }
      return status
    }
  }
}
</script>

<style scoped>
  /* .flight-box {
    padding-bottom: 80px;
  } */

</style>
